import { parsePhoneNumber } from 'libphonenumber-js';
import { formatPhone, normalizePhone } from '../utils/format';

/**
 * Convertit un code ISO pays (ex: 'GP') en URL Twemoji (même rendu que Google/Android).
 * Fonctionne sur tous les OS y compris Windows.
 */
const countryToFlagUrl = (code) => {
  if (!code || code.length !== 2) return null;
  const codepoints = code.toUpperCase().split('')
    .map(c => (0x1F1E6 + c.charCodeAt(0) - 65).toString(16))
    .join('-');
  return `https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/${codepoints}.svg`;
};

/** Détecte le code pays ISO depuis un numéro (E.164 ou local) */
const getCountry = (raw) => {
  if (!raw) return null;
  const clean = String(raw).replace(/[\s\-\.\(\)]/g, '');
  try {
    const parsed = parsePhoneNumber(clean, clean.startsWith('+') ? undefined : 'FR');
    return parsed?.country || null;
  } catch (_) { return null; }
};

/**
 * Champ de saisie téléphone avec drapeau pays et formatage automatique.
 *
 * - Stockage : E.164 brut (+33611223344) au blur
 * - Affichage : format international lisible (+33 6 11 22 33 44)
 * - Drapeau : image Twemoji (même rendu que Google/Android), compatible Windows
 */
export function PhoneInput({ value, onChange, className, style, onBlur, ...props }) {
  const country   = getCountry(value);
  const flagUrl   = countryToFlagUrl(country);
  const displayed = formatPhone(value) || value || '';

  const handleChange = (e) => {
    onChange({ target: { value: e.target.value } });
  };

  const handleBlur = (e) => {
    const normalized = normalizePhone(e.target.value);
    if (normalized !== e.target.value) {
      onChange({ target: { value: normalized } });
    }
    onBlur?.(e);
  };

  return (
    <div className="relative flex items-center" style={{ width: '100%' }}>
      {flagUrl && (
        <img
          src={flagUrl}
          alt={country}
          style={{
            position: 'absolute', left: 8,
            width: 18, height: 13,
            borderRadius: 2,
            objectFit: 'cover',
            pointerEvents: 'none', userSelect: 'none',
            flexShrink: 0,
          }}
        />
      )}
      <input
        type="tel"
        value={displayed}
        onChange={handleChange}
        onBlur={handleBlur}
        className={className}
        style={{ ...style, paddingLeft: flagUrl ? 34 : undefined }}
        {...props}
      />
    </div>
  );
}
